import React, { useEffect, useState } from "react";
import LoadCSSforfirstTime from "../../../../../CloudStorage/LoadCSSforfirstTime";
import CloudStorage from "../../../../../CloudStorage/CloudStorage";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import SignProjectContract from "./SignProjectContract";
import { getProjectProposalById } from "../../../../../redux/project/action";
import { Tooltip } from "react-tooltip";
import {
  formatNumberWithCommas,
  getDeadlineDate,
  getMemberSince,
  getTodaydate,
  today,
} from "../../../../Common/AllDateTimeReleventFormate";
import { addpresent } from "../../../../Common/FewCommonMethods";
import { storage } from "../../../../../Firebase/config";
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import html2canvas from "html2canvas";
import RoleLabel from "../../../../Common/RoleLabel";
import ClientUserCommonDetails from "../../../../Common/ClientUserCommonDetails";
import ContractView from "../../../../CustomComponents/ContractView";
import { penaltytips } from "../../../../Common/Tooltips/tooltip";


export default function ProjectContract() {
  const path = "Assets/scss/FindWork.module.scss";
  useEffect(() => {
    LoadCSSforfirstTime(path);
  }, [path]);
  const laung = localStorage.getItem("laung");
  const [lan, setLan] = useState(laung ?? "en");
  const navigate = useNavigate();

  const { id } = useParams();
  const pbi = useSelector(
    ({ project: { getprojectproposalbyid } }) => getprojectproposalbyid,
  );
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getProjectProposalById(id));
  }, [id]);

  return (
    <div className="container-fluid contract">
      <div className="project-offer project-details col-lg-10 mx-auto">
        {/* <p className="breadcrumbs">
          <a onClick={() => navigate(-2)}>My orders &gt; </a>
          <a onClick={() => navigate(-1)}>All proposal &gt;</a> Submit
          proposal
        </p> */}
        <p className="breadcrumbs">
           <a onClick={() => navigate(-2)}>{pbi?.is_mine == 1 ? "Manage Work" : "My Order"} &gt; </a>
          <a onClick={() => navigate(-1)}>{pbi?.is_mine == 1 ? "PBP Details" : "All Proposal"} &gt; </a>
          {pbi?.is_mine == 1 ? "Accept Offer" : "Send Offer"}
        </p>
        <div id='take-screenshot-for-this-form' className="col-lg-10 mx-auto">
          <div className="contract-sec" id="capture-contract-section">
            <img
              src={`${CloudStorage.cloudurl}/Assets/Images/project/contract-logo.svg`}
              alt=""
            />
            <div className="flex-sec">
              <p>Date : {getMemberSince(today)}</p>
              <p>ID : {pbi?.agreement_id}</p>
            </div>
            <div className="website-design">
              <ContractView type={'project_agreement'} />
            </div>
            <div className="project-details">
              <div className="flex-sec">
                <p>Project Details</p>
              </div>
              <div className="flex-sec flex-sec1">
                <p>Budget</p>
                <p>SAR {formatNumberWithCommas(pbi?.price)}</p>
              </div>
              <div className="flex-sec flex-sec1">
                <p>Deadline</p>
                <p>{getDeadlineDate(pbi?.duration_type, pbi?.duration)}</p>
              </div>
              <div className="flex-sec flex-sec1">
                <p>Payment milestones</p>
                <p>{pbi?.milestones?.length}</p>
              </div>
            </div>

            <div className="project-details">
              <div className="flex-sec">
                <p>Agreed milestones</p>
              </div>
              <div className="table-responsive">
                <table className="table ">
                  <thead>
                    <th>Milestones</th>
                    <th>Deadline</th>
                    <th>Amount</th>
                    <th>
                      Penalty
                      <img
                        data-tooltip-id="my-tooltip-1"
                        src={`${CloudStorage.cloudurl}/Assets/Images/project/penalty.svg`}
                        alt=""
                      />
                    </th>
                  </thead>
                  <tbody>
                    {Array.isArray(pbi?.milestones) &&
                      pbi?.milestones.map((item, index) => (
                        <tr>
                          <td>
                            {index + 1}. {item.title}
                          </td>
                          <td>
                            {item.duration}{' '}
                            {item?.duration_type == 1
                              ? "Hour"
                              : item?.duration_type == 2
                                ? "Days"
                                : item?.duration_type == 3
                                  ? "Weeks"
                                  : item?.duration_type == 4
                                    ? "Months"
                                    : ""}
                          </td>
                          <td>SAR {formatNumberWithCommas(item.amount)} </td>
                          <td>{addpresent(item.penalty)}</td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
            </div>
            <ClientUserCommonDetails pbi={pbi} />
            <SignProjectContract pbi={pbi} />
          </div>
        </div>
      </div>
      <Tooltip
        id="my-tooltip-1"
        place="bottom"
        content={penaltytips}
      />
    </div>
  );
}
